import { useCallback, useRef, useState } from 'react';

/**
 * Encapsula el flujo de captura fotográfica de un turno en dos pasos:
 * selfie (cámara frontal, firma visual) y evidencia (cámara trasera,
 * horómetro + nivel de estanque). El atributo `capture` del input fuerza
 * apertura directa de cámara en móviles; en desktop abre el selector de
 * archivos normal.
 */
export function useFuelCapture() {
  const [selfieFile, setSelfieFile] = useState<File | null>(null);
  const [evidenciaFile, setEvidenciaFile] = useState<File | null>(null);

  const selfieInputRef = useRef<HTMLInputElement | null>(null);
  const evidenciaInputRef = useRef<HTMLInputElement | null>(null);

  const crearInput = (capture: 'user' | 'environment', onChange: (file: File) => void) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.setAttribute('capture', capture);
    input.style.display = 'none';
    input.onchange = () => {
      const file = input.files?.[0];
      if (file) onChange(file);
      document.body.removeChild(input);
    };
    document.body.appendChild(input);
    return input;
  };

  const capturarSelfie = useCallback(() => {
    const input = crearInput('user', setSelfieFile);
    selfieInputRef.current = input;
    input.click();
  }, []);

  const capturarEvidencia = useCallback(() => {
    const input = crearInput('environment', setEvidenciaFile);
    evidenciaInputRef.current = input;
    input.click();
  }, []);

  const resetear = useCallback(() => {
    setSelfieFile(null);
    setEvidenciaFile(null);
  }, []);

  return {
    selfieFile,
    evidenciaFile,
    capturarSelfie,
    capturarEvidencia,
    listo: !!selfieFile && !!evidenciaFile,
    resetear,
  };
}

export default useFuelCapture;
